var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidepassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50705 9.57787C6.12371 9.1952 5.89038 8.6752 5.89038 8.09187C5.89038 6.9232 6.83171 5.9812 7.99971 5.9812C8.57771 5.9812 9.10971 6.2152 9.48638 6.59787",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0698 8.46582C9.91509 9.32582 9.23775 10.0045 8.37842 10.1605",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43634 11.6482C3.37834 10.8176 2.48234 9.60423 1.83301 8.09157C2.48901 6.57223 3.39101 5.35223 4.45567 4.5149C5.51367 3.67757 6.73434 3.2229 7.99967 3.2229C9.27234 3.2229 10.4923 3.68423 11.557 4.52757",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.965 5.9939C13.4236 6.60323 13.827 7.30656 14.1663 8.09123C12.855 11.1292 10.5376 12.9592 7.99965 12.9592C7.42431 12.9592 6.85698 12.8659 6.31165 12.6839",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2579 2.83301L2.74194 13.349",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidepassword);
export default __webpack_public_path__ + "static/media/hidepassword.c2c86c19f987e10b2c19c794e1c05459.svg";
export { ForwardRef as ReactComponent };